import * as React from "react";
import { Car, ChevronRight, Settings, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const services = [{
  title: "Facility Management",
  description: "Comprehensive oversight of ASC operations, ensuring full regulatory compliance and peak performance across all surgical environments.",
  icon: Wrench,
  href: "/FacilitiesPage"
}, {
  title: "Clinician Partnerships",
  description: "Strategic support for physicians, providing the necessary infrastructure and resources to deliver exceptional patient outcomes.",
  icon: Car,
  href: "/CliniciansPage"
}, {
  title: "Operational Systems",
  description: "Optimizing supply chains and administrative workflows to enhance efficiency and clinical quality throughout your organization.",
  icon: Settings,
  href: "/AtlasSurgicalPartnersPage"
}];
export default function OurServices() {
  return;
}